/* eslint-disable jsx-a11y/anchor-is-valid */
/**Validations */
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { InscripcionRequest } from '../../models/requests';
import { ChangeEvent, useState } from 'react';
/**Utilities */
import { ErrorValidate, ErrorBackend, SweetAlert } from '../../utilities';
import { useBecas } from '../../hooks/useBecas';

export const RegisterPage = () => {
  const defaultFormData: InscripcionRequest = {
    sede: '',
    document: '',
    names: '',
    father_last_name: '',
    mother_last_name: '',
    email: '',
    cellphone: '',
    group_id: '',
  };
  const [formData, setFormData] = useState<InscripcionRequest>(defaultFormData);
  const { storeBeca } = useBecas();
  const [stateView, setStateView] = useState<boolean>(false);
  const [code, setCode] = useState<string>('');
  const [sede, setSede] = useState<string>('');
  const [errors, setErrors] = useState<string[]>([]);

  const validationSchema = Yup.object().shape({
    sede: Yup.string().required("El campo 'Sede' es obligatorio."),
    document: Yup.string().required("El campo 'DNI' es obligatorio."),
    names: Yup.string().required("El campo 'Nombres' es obligatorio."),
    father_last_name: Yup.string().required("El campo 'Apellido paterno' es obligatorio."),
    mother_last_name: Yup.string().required("El campo 'Apellido materno' es obligatorio."),
    cellphone: Yup.string().required("El campo 'Celular' es obligatorio."),
    group_id: Yup.string().required("El campo 'Grupo' es obligatorio."),
  });

  const formik = useFormik({
    initialValues: formData,
    validationSchema,
    onSubmit: () => {
      console.log(formData);
      storeBeca(formData)
        .then((response) => {
          console.log(response);
          setStateView(true);
          setCode(response.code);
          setSede(response.sede);
          setFormData(defaultFormData);
          formik.resetForm();
        })
        .catch((error) => {
          console.log(error.response.data.errors);
          setErrors(error.response.data.errors);
          SweetAlert.warning('Mensaje', 'Verifique los datos de su inscripción.');
        });
    },
  });

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    formik.handleChange(event);
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
    formik.handleChange(event);
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const finalizar = () => {
    setStateView(false);
    setCode('');
    setSede('');
    setErrors([]);
  };

  return (
    <div className="min-vh-100 row justify-content-center align-items-center">
      <div className="col-md-7">
        <form className="form form-horizontal" onSubmit={formik.handleSubmit}>
          <div className="card card-featured card-featured-primary mb-3 mt-3">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12 mb-3 text-center">
                  <img src="/images/logo.png" alt="" className="logo-inscription" />
                  <h4 className="mt-3">Inscripción - Examen de becas</h4>
                </div>
                {!stateView && (
                  <>
                    <div className="form-group col-md-6">
                      <label htmlFor="sede" className="form-label">
                        Sede<span className="text-danger">*</span>
                      </label>
                      <select
                        id="sede"
                        name="sede"
                        onChange={handleSelectChange}
                        className={
                          'form-control form-control-sm form-select' + (formik.errors.sede && formik.touched.sede ? ' is-invalid' : '')
                        }
                      >
                        <option value="">Seleccionar</option>
                        <option value="TUCUME">TÚCUME</option>
                        <option value="JAYANCA">JAYANCA</option>
                      </select>
                      <ErrorValidate state={formik.errors.sede} />
                      <ErrorBackend errorsBackend={errors} name="sede" />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="document" className="form-label">
                        DNI<span className="text-danger">*</span>
                      </label>
                      <input
                        name="document"
                        onChange={handleInputChange}
                        value={formik.values.document}
                        autoComplete="off"
                        type="text"
                        className={
                          'todo-mayuscula form-control form-control-sm' +
                          (formik.errors.document && formik.touched.document ? ' is-invalid' : '')
                        }
                        id="document"
                      />
                      <ErrorValidate state={formik.errors.document} />
                      <ErrorBackend errorsBackend={errors} name="beca" />
                      <ErrorBackend errorsBackend={errors} name="document" />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="names" className="form-label">
                        Nombres<span className="text-danger">*</span>
                      </label>
                      <input
                        name="names"
                        onChange={handleInputChange}
                        value={formik.values.names}
                        autoComplete="off"
                        type="text"
                        className={
                          'todo-mayuscula form-control form-control-sm' + (formik.errors.names && formik.touched.names ? ' is-invalid' : '')
                        }
                        id="names"
                      />
                      <ErrorValidate state={formik.errors.names} />
                      <ErrorBackend errorsBackend={errors} name="beca.names" />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="father_last_name" className="form-label">
                        Apellido paterno<span className="text-danger">*</span>
                      </label>
                      <input
                        name="father_last_name"
                        onChange={handleInputChange}
                        value={formik.values.father_last_name}
                        autoComplete="off"
                        type="text"
                        className={
                          'todo-mayuscula form-control form-control-sm' +
                          (formik.errors.father_last_name && formik.touched.father_last_name ? ' is-invalid' : '')
                        }
                        id="father_last_name"
                      />
                      <ErrorValidate state={formik.errors.father_last_name} />
                      <ErrorBackend errorsBackend={errors} name="beca.father_last_name" />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="mother_last_name" className="form-label">
                        Apellido materno<span className="text-danger">*</span>
                      </label>
                      <input
                        name="mother_last_name"
                        onChange={handleInputChange}
                        value={formik.values.mother_last_name}
                        autoComplete="off"
                        type="text"
                        className={
                          'todo-mayuscula form-control form-control-sm' +
                          (formik.errors.mother_last_name && formik.touched.mother_last_name ? ' is-invalid' : '')
                        }
                        id="mother_last_name"
                      />
                      <ErrorValidate state={formik.errors.mother_last_name} />
                      <ErrorBackend errorsBackend={errors} name="beca.mother_last_name" />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="email" className="form-label">
                        Correo
                      </label>
                      <input
                        name="email"
                        onChange={handleInputChange}
                        value={formik.values.email}
                        autoComplete="off"
                        type="text"
                        className="form-control form-control-sm"
                        id="email"
                      />
                      <ErrorBackend errorsBackend={errors} name="beca.email" />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="cellphone" className="form-label">
                        Celular<span className="text-danger">*</span>
                      </label>
                      <input
                        name="cellphone"
                        onChange={handleInputChange}
                        value={formik.values.cellphone}
                        autoComplete="off"
                        type="text"
                        className={
                          'todo-mayuscula form-control form-control-sm' +
                          (formik.errors.cellphone && formik.touched.cellphone ? ' is-invalid' : '')
                        }
                        id="cellphone"
                      />
                      <ErrorValidate state={formik.errors.cellphone} />
                      <ErrorBackend errorsBackend={errors} name="beca.cellphone" />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="group_id" className="form-label">
                        Grupo<span className="text-danger">*</span>
                      </label>
                      <select
                        onChange={handleSelectChange}
                        value={formik.values.group_id ?? ''}
                        name="group_id"
                        className={
                          'form-control form-control-sm form-select' +
                          (formik.errors.group_id && formik.touched.group_id ? ' is-invalid' : '')
                        }
                        id="group_id"
                      >
                        <option value="">Seleccionar</option>
                        <option value="1">Grupo 1 - CIENCIAS MÉDICAS</option>
                        <option value="2">Grupo 2 - CIENCIA POLÍTICA Y DERECHO</option>
                        <option value="3">Grupo 3 - CIENCIAS ECONÓMICAS</option>
                        <option value="4">Grupo 4 - CIENCIAS SOCIALES</option>
                        <option value="5">Grupo 5 - CIENCIAS E INGENIERÍAS</option>
                        <option value="6">Grupo 6 - INGENIERÍAS AGROPECUARIAS</option>
                      </select>
                      <ErrorValidate state={formik.errors.group_id} />
                      <ErrorBackend errorsBackend={errors} name="beca.group_id" />
                    </div>
                  </>
                )}
                {stateView && (
                  <div className="form-group col-md-12">
                    <div className="alert alert-success alert-dismissible" role="alert">
                      <strong> MENSAJE:</strong> Inscripción registrada correctamente.
                    </div>
                    <p className="m-0">
                      <b>Código para el examen:</b> {code}
                    </p>
                    <p className="m-0">
                      <b>Sede del examen:</b> {sede}
                    </p>
                    <p className="m-0">
                      <b>
                        <i className="ri-timer-line"></i> Fecha y hora del examen:
                      </b>{' '}
                      05 de Abril del 2025 a las 09:00am a 12:00pm
                    </p>
                    <br />
                    <p>
                      <i className="ri-information-line"></i> Para más informes escríbenos al whastapp o llámanos al <b>943 904 329</b>
                    </p>
                    <p>
                      <b>
                        <i className="ri-map-pin-line"></i> Ubicanos en:
                      </b>
                    </p>
                    <p className="m-0">
                      <b>Sede Jayanca - Calle Villavivencio 495 (Costado del mercado)</b>
                    </p>
                    <p className="m-0">
                      <b>Sede Túcume - Calle Daniel Aldana 495 (Iglesia la cosecha)</b>
                    </p>
                  </div>
                )}
              </div>
            </div>
            {!stateView && (
              <div className="card-footer text-center">
                <button type="submit" className="btn btn-primary btn-lg btn-block ps-5 pe-5">
                  Inscribirse
                </button>
              </div>
            )}
            {stateView && (
              <div className="card-footer text-center">
                <button onClick={finalizar} type="button" className="btn btn-success btn-lg btn-block ps-5 pe-5">
                  Finalizar inscripción
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterPage;
